import { render, staticRenderFns } from "./KarmaCategoryAdd.vue?vue&type=template&id=014112c8&"
import script from "./KarmaCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./KarmaCategoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./KarmaCategoryAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports